import { render, staticRenderFns } from "./addSubdivisionComponent.vue?vue&type=template&id=198eae95&scoped=true"
import script from "./addSubdivisionComponent.vue?vue&type=script&lang=js"
export * from "./addSubdivisionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198eae95",
  null
  
)

export default component.exports